// /profiles redirects to the parent Kids tab at /parent/kids (MA-852; it
// used to target /parent/settings/kids, which now redirects there too).
// Mirrors dashboard.tsx / settings.tsx. The legacy ProfilesScreen.jsx it
// used to render has been deleted; this redirect route is kept so any
// lingering /profiles link still lands correctly. The search string rides
// along (e.g. ?dev=1).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/profiles")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/parent/kids", search: location.search as never, replace: true });
  },
  component: () => null,
});
